const Joi = require('joi')

export const teamSchema = Joi.object({
  name: Joi.string().trim().min(4).max(40).required().messages({
    'string.empty': `Name cannot be an empty field`,
    'any.required': `Name is a required field`,
    'string.min': `Name length must be at least 4 characters long`,
    'string.max': `Name length must be less than or equal to 40 characters`,
  }),
  description: Joi.string().empty('').allow(null).max(500).messages({
    'string.max': `Description length must be less than or equal to 500 characters`,
  }),
  assigneeIds: Joi.array().items(Joi.number().required()).messages({
    'array.includesRequiredUnknowns': `Atleast 1 member must be selected`,
  }),
})
